import { isAccountSourceListStoreInitialized } from 'owa-account-source-list-store';
import { logStartGreyError } from 'owa-analytics-start';
import type { MailboxInfo } from 'owa-client-types';
import { getAccountSettingsInternal } from './getAccountSettingsInternal';
import { mailboxInfoOrTemporaryGlobal } from './mailboxInfoOrTemporaryGlobal';
import { getSharedMailboxFolderInformationMap } from './sharedMailboxFolderInformationUtils';
import type DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';

export default function folderNameToId(
    folderName: DistinguishedFolderIdName,
    mailboxInfo?: MailboxInfo,
    shouldSearchShared?: boolean
): string {
    if (!folderName) {
        const error = new Error('FolderNameToIdInvalidParameters');

        /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
         * BASELINE: DO NOT COPY/PASTE!
         *	> Argument at index 1 for logStartGreyError must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
        logStartGreyError('FolderNameToIdInvalidParameters', undefined, error);
        return '';
    }

    if (!isAccountSourceListStoreInitialized()) {
        const error = new Error('FolderNameToIdUninitializedAccountSourceListStore');

        /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
         * BASELINE: DO NOT COPY/PASTE!
         *	> Argument at index 1 for logStartGreyError must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
        logStartGreyError('FolderNameToIdUninitializedAccountSourceListStore', undefined, error);
        return '';
    }

    if (shouldSearchShared && mailboxInfo?.type == 'SharedMailbox') {
        const mailboxInformation = getSharedMailboxFolderInformationMap(mailboxInfo);
        if (mailboxInformation) {
            const folderId = mailboxInformation.defaultFolderNameToIdMap?.get(folderName);
            return folderId ?? '';
        }
    }

    const settings = getAccountSettingsInternal(mailboxInfoOrTemporaryGlobal(mailboxInfo));
    const folderId = settings?.defaultFolderNameToIdMap?.get(folderName);
    return folderId ?? '';
}
